import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Row,
  Typography,
} from '@tempmee/react';
import { useSalesMetroZips } from '../../../../domain/SalesMetros';
import { Spinner } from '../../../commonComponents/Spinner';

const ZipsBody = ({ zips, isPending, isError }) => {
  if (isPending) return <Spinner />;
  if (isError) return <Typography className="text-error">Could not load zip codes.</Typography>;
  if (zips.length === 0) return <Typography>This metro has no zip codes.</Typography>;

  return (
    <Row gap={2} wrap="wrap">
      {zips.map((zip) => (
        <Chip key={zip} label={zip} />
      ))}
    </Row>
  );
};

ZipsBody.propTypes = {
  zips: PropTypes.arrayOf(PropTypes.string).isRequired,
  isPending: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
};

/**
 * The zips one metro owns, read-only — adding or removing zips is not in the
 * MVP (GOTU-6009). Mounted only while open, so it reads when an admin asks.
 */
export const MetroZipsDialog = ({ metro, onClose }) => {
  const { zips, isPending, isError } = useSalesMetroZips(metro.id);

  return (
    <Dialog open onClose={onClose}>
      {/* "Dismiss dialog" so the X and the Close action are not two buttons
          with one name. */}
      <DialogTitle closeLabel="Dismiss dialog">{`${metro.name} Zip Codes`}</DialogTitle>

      <DialogContent>
        {/* The DS Dialog panel has no max height and the body scroll is
            locked behind it, so a metro with hundreds of zips scrolls here. */}
        <Box className="overflow-y-auto max-h-96">
          <ZipsBody zips={zips} isPending={isPending} isError={isError} />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MetroZipsDialog.propTypes = {
  metro: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MetroZipsDialog;
